import { render } from "./CampaignActivities.vue?vue&type=template&id=7a62fffa&scoped=true"
import script from "./CampaignActivities.vue?vue&type=script&lang=js"
export * from "./CampaignActivities.vue?vue&type=script&lang=js"

import "./CampaignActivities.vue?vue&type=style&index=0&id=7a62fffa&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a62fffa"]])

export default __exports__